import type {ServicePricesState} from "./types";
import {type ServicePriceAction, ServicePriceActionType} from "../actions/ServicePriceActions";


export const initialServicePricesState: ServicePricesState = {
  pending: false,
  error: '',
  pricing: {
    hydrolinkApiPrice: 0,
    hydrolinkPremiumPrice: 0,
    vatMultiplier: 0
  }

}

export function servicePriceReducer(state = initialServicePricesState, action: ServicePriceAction): ServicePricesState {
  if (action.type === ServicePriceActionType.SERVICE_PRICES_PENDING) {
    return {
      ...state,
      error: '',
      pending: true
    }
  }

  if (action.type === ServicePriceActionType.SERVICE_PRICES_REJECTED) {
    return {
      ...state,
      pending: false,
      error: action.payload.error
    }
  }

  if (action.type === ServicePriceActionType.SERVICE_PRICES_FULFILLED) {
    return {
      ...state,
      pending: false,
      error: '',
      pricing: {
        ...action.payload
      }
    }
  }

  return state
}
